module.exports = __webpack_public_path__ + "assets/ic-coinmarketcap.ab9c0572.svg";